import { FaAward } from 'react-icons/fa'
import { TbBooks } from 'react-icons/tb'
import { BiHappyHeartEyes } from 'react-icons/bi'

const data = [
  {
    id: 1,
    icon: <FaAward />,
    title: 'Experience',
    desc: '+10 years hands on experiences',
  },
  {
    id: 2,
    icon: <TbBooks />,
    title: 'Projects',
    desc: '+100 Completed',
  },
  {
    id: 3,
    icon: <BiHappyHeartEyes />,
    title: 'Customers',
    desc: '+100 Satisfied',
  },
]

export default data
